import { AppBuilders, UIKit } from "@cheshire-datasystems/toren-utilities";
import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";
import DesignTokens from "@cheshire-datasystems/designtokens";
import { name, version } from "../package.json";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    if (window.dtrum) {
      window.dtrum.reportError(
        `Error in ${name}@${version}: ${err.message}\n${err.stack}`
      );
    }

    const layoutConfig =
      props.shared_structures["mf-parcel-custom-error-view-structure"];
    return (
      <>
        <UIKit.ThemeProvider
          theme={{
            tokens: DesignTokens,
          }}
        >
          <AppBuilders
            config={layoutConfig}
            siteConfig={{}}
            actions={{}}
            initialState={{}}
            //@ts-ignore
            slices={{}}
          />
        </UIKit.ThemeProvider>
      </>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
